/* global AOS */
jQuery(function($){
	
	// Refresh AOS after content has been expanded or collapsed
	// Fixes issue where AOS animated content doesn't display 
	// after expand block has been used on a page by the user
	$('.ub-expand-toggle-button').on('click', function(){
		if (typeof AOS !== 'undefined') {
			AOS.refresh();
		}
	});
	
});